import { ScrollView } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
import type { ReactNode } from "react";

interface WebRightPanelProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function WebRightPanel({ title, subtitle, children }: WebRightPanelProps) {
  const { theme } = useUnistyles();

  return (
    <View flex={1} height="100%">
      {/* Header */}
      <View mb="6xl" gap="xs">
        <Text textStyle="sm/regular" color="text">
          {title}
        </Text>
        {subtitle && (
          <Text textStyle="xs/regular" color="textMuted">
            {subtitle}
          </Text>
        )}
      </View>

      {/* Separator */}
      <View height={1} bg="borderCard" mb="6xl" />

      {/* Content */}
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{
          paddingBottom: theme.spacing["6xl"],
        }}
        showsVerticalScrollIndicator={false}
      >
        {children}
      </ScrollView>
    </View>
  );
}
